export const EVENT_MODAL = {
  HEADER_TITLE: `Assign Students to Activities`,
  SYLLABUS_TYPE_LABEL: 'Activity Set Type',
  SYLLABUS_LABEL: 'Activity Set',
  ENROLMENT_LABEL: 'Enrolment',
};

export const EVENT_PHASES = {
  PREP: 'PREP',
  BRIEF: 'BRIEF',
  POST: 'POST',
  DEBRIEF: 'DEBRIEF',
  EVENT: 'EVENT'
};

export const EVENT_PHASES_ORDER = [
  EVENT_PHASES.PREP, EVENT_PHASES.BRIEF, EVENT_PHASES.EVENT, EVENT_PHASES.DEBRIEF, EVENT_PHASES.POST
];

export const EVENT_STATUS = {
  CANCELLED: 'CANCELLED',
  COMPLETED: 'COMPLETED',
  ON_HOLD: 'ON_HOLD',
  PLANNED: 'PLANNED',
  DNCO: 'DNCO',
  DPCO: 'DPCO',
};

export const EVENT_TYPES = {
  BRIEF: 'Brief',
  COHORT: 'Cohort_Event',
  FCF_GR: 'FCF_GR',
  FLIGHT: 'Flight_Event',
  GROUND: 'Ground_Event',
  SIM: 'Simulator_Event',
};

export const FLYPRO_GROUP_UNALLOCATED_EVENTS = {
  id: 'others-group',
  background_color: '#0b47a6',
  foreground_color: 'White',
  display_order: 1000,
  flying_event: false,
  meeting_event: false,
  other_event: false,
  simulator_event: false,
  flypro_group_human_list: [],
  flypro_group_resource_list: [],
  flypro_group_syllabus_type_list: [],
  is_visible: false,
  is_collapsed: true,
  is_compact: false,
  name: 'Others',
  school_id: null,
  isUnallocatedGroup: true
};

export const SCHEDULED_EVENT_TYPES = {
  FLIGHT_EVENT: 'FLIGHT_EVENT',
  SIMULATOR_EVENT: 'SIMULATOR_EVENT',
  MEETING: 'MEETING',
  COHORT_EVENT: 'COHORT_EVENT',
  GROUND_EVENT: 'GROUND_EVENT',
  OTHER: 'OTHER',
};

export const SCHEDULED_EVENT_TYPES_DISPLAY_NAME = {
  FLIGHT_EVENT: 'FLIGHT',
  SIMULATOR_EVENT: 'SIMULATOR',
  MEETING: 'MEETING',
  COHORT_EVENT: 'COHORT',
  GROUND_EVENT: 'GROUND',
  OTHER: 'OTHER',
};

export const EVENT_TYPE_DISPLAY_NAME = {
  [EVENT_TYPES.FLIGHT]: 'Flight',
  [EVENT_TYPES.SIM]: 'Simulator',
  [EVENT_TYPES.GROUND]: 'Ground School',
  [EVENT_TYPES.COHORT]: 'Cohort',
  [EVENT_TYPES.FCF_GR]: 'FCF/GR',
};

export const FlyProUI = {
  BRIEF_EVENT_LANE_HEIGHT: 100,
  DEFAULT_ROW_HEIGHT: 60,
  EXPANDED_CALENDAR_WIDTH: '100%',
  FCF_EVENT_LANE_HEIGHT: 160,
  LANE_HEIGHT: 161,
  PRINT_LANE_HEIGHT: 120,
  GROUND_EVENT_LANE_HEIGHT: 78,
  HIDDEN_SIDEBAR_WIDTH: '3px',
  MAX_RIBBON_CONTAINER_WIDTH: 52,
  MAX_RIBBON_OFFSET: 13,
  MAX_RIBBON_WIDTH: 93,
  MAX_SORTIES_Z_INDEX: 999,
  MIN_SORTIES_Z_INDEX: 100,
  ORIGIN_Y: 1,
  SIM_EVENT_LANE_HEIGHT: 210,
  SORTIE_ABBREV_WIDTH: 130,
  SORTIE_ABBREV_WIDTH_RESOURCE: 70,
  SORTIE_CHUNK_WIDTH: 25,
  SWIMLANE_HEADER_WIDTH: 100,
  SWIMLANE_HEIGHT_COMPACT: 19,
};

export const FLY_PRO_DEFAULT_COUNT_DOWN_TIME = 1200000;

export const FLY_PRO_MONTH_VIEW_TYPES = {
  ...EVENT_TYPES,
  EXTERNAL_BOOKING: 'external_booking',
  LOCKED: 'locked',
  HIGH_PRIORITY: 'High_priority',
};

export const FLY_PRO_MONTH_VIEW_CALENDARS = [
  {
    id: FLY_PRO_MONTH_VIEW_TYPES.HIGH_PRIORITY,
    name: 'High Priority',
    color: '#ffffff',
    bgColor: '#ffba3b',
    dragBgColor: '#ffba3b',
    borderColor: '#ffba3b',
  },
  {
    id: FLY_PRO_MONTH_VIEW_TYPES.EXTERNAL_BOOKING,
    name: 'Required External Booking Events',
    color: '#ffffff',
    bgColor: '#de6969',
    dragBgColor: '#de6969',
    borderColor: '#de6969',
  },
  {
    id: FLY_PRO_MONTH_VIEW_TYPES.LOCKED,
    name: 'Locked Events',
    color: '#ffffff',
    bgColor: '#82149e',
    dragBgColor: '#82149e',
    borderColor: '#82149e',
  },
  {
    id: FLY_PRO_MONTH_VIEW_TYPES.FLIGHT,
    name: 'Flying Events',
    color: '#ffffff',
    bgColor: '#03b0f0',
    dragBgColor: '#03b0f0',
    borderColor: '#03b0f0'
  },
  {
    id: FLY_PRO_MONTH_VIEW_TYPES.FCF_GR,
    name: 'FCF/GR Events',
    bgColor: '#8d9db6',
    dragBgColor: '#8d9db6',
    borderColor: '#8d9db6'
  },
  {
    id: FLY_PRO_MONTH_VIEW_TYPES.SIM,
    name: 'Simulator Events',
    color: '#ffffff',
    bgColor: 'lightseagreen',
    dragBgColor: 'lightseagreen',
    borderColor: 'lightseagreen'
  },
  {
    id: FLY_PRO_MONTH_VIEW_TYPES.GROUND,
    name: 'Ground School Events',
    color: '#ffffff',
    bgColor: '#3C4DFF',
    dragBgColor: '#3C4DFF',
    borderColor: '#3C4DFF'
  }
];

/**
 * Lesson types
 */
export const LESSON_TYPES = {
  FLY: 'Flight',
  // FCF_GR: 'FCF/GR',
  SIM: 'Simulation',
  COHORT: 'Ground school',
  MEETING: 'Meeting Event',
  OTHERS: 'Others',
};

export const SCHEDULED_EVENT_TYPE_OPTIONS = [
  { value: SCHEDULED_EVENT_TYPES.FLIGHT_EVENT, label: SCHEDULED_EVENT_TYPES_DISPLAY_NAME.FLIGHT_EVENT },
  { value: SCHEDULED_EVENT_TYPES.SIMULATOR_EVENT, label: SCHEDULED_EVENT_TYPES_DISPLAY_NAME.SIMULATOR_EVENT },
  { value: SCHEDULED_EVENT_TYPES.MEETING, label: SCHEDULED_EVENT_TYPES_DISPLAY_NAME.MEETING },
  { value: SCHEDULED_EVENT_TYPES.COHORT_EVENT, label: SCHEDULED_EVENT_TYPES_DISPLAY_NAME.COHORT_EVENT },
  { value: SCHEDULED_EVENT_TYPES.GROUND_EVENT, label: SCHEDULED_EVENT_TYPES_DISPLAY_NAME.GROUND_EVENT },
  { value: SCHEDULED_EVENT_TYPES.OTHER, label: SCHEDULED_EVENT_TYPES_DISPLAY_NAME.OTHER }
];

export const SWIMLANE_LABEL = {
  UNALLOCATED_EVENTS: 'Unallocated Events'
};

export const EVENT_FORM_ERROR_TYPES = {
  DUPLICATE_STUDENTS: 'DUPLICATE_STUDENTS',
  EMPTY_SCHOOL: 'EMPTY_SCHOOL',
};

export const EVENT_REPRESENTATION = {
  properties: {
    HUMANS_CURRENTLY_ENROLLED_IN_SOURCE_LESSONS: 'humans_currently_enrolled_in_source_lessons',
    HUMANS_CURRENTLY_ENROLLED_IN_SOURCE_LESSON: 'humans_currently_enrolled_in_source_lesson',
    HUMANS_CURRENTLY_ENROLLED_IN_TARGET_LESSON: 'humans_currently_enrolled_in_potential_target_lessons',
    COHORTS: 'existing_cohorts',
    CONSOLIDATED_REQUIREMENTS: 'consolidated_requirements',
    ENROLMENTS_LAST_PARTIAL_EVENT: 'all_enrolments_with_last_partial_event',
    LESSON_PHASES: 'lesson_phases',
    SCHEDULED_EVENT_TYPE: 'scheduled_event_type'
  },
  labels: {
    HUMANS_CURRENTLY_ENROLLED_IN_SOURCE_LESSON: 'Enrolled In Source Activity',
    HUMANS_CURRENTLY_ENROLLED_IN_TARGET_LESSON: 'Enrolled In Target Activity',
    COHORTS: 'Cohorts with applicable students',
  }
};

export const PROPAGATE_SOURCE = {
  QUICK_SETUP: 'QUICK_SETUP',
  EVENT_PHASE: 'EVENT_PHASE',
};

// Section titles
export const SECTION_TITLES = {
  LESSON: 'Activity Details',
  LESSONS: 'Activities Details',
  TIMELINE: 'Timeline Preview',
  QUICK_SETUP: 'Setup',
  PHASES: 'Phase Details'
};

// Tooltip messages
export const TOOLTIPS = {
  ADDITIONAL_CREW_ADD: 'Add additional crew',
  ADDITIONAL_RESOURCE_ADD: 'Add additional resource',
  ADDITIONAL_RESOURCE_REMOVE: 'Remove',
  BASE_CONFIG: 'Base Config',
  CLOSE_SIDEBAR: 'Hide Sidebar',
  CONFIG_TAG: (isBase, description) => `${isBase ? '[BASE] ' : ''}${description}`,
  CONFIGS: 'Required configuration(s)',
  OPEN_PERSONNEL_SIDEBAR: 'Show Personnel',
  OPEN_LESSON_GUIDE_SIDEBAR: 'Show Activity Guides',
  OPEN_ACTIVITY_REQUEST_SIDEBAR: 'Show Activity Requests',
  QUALIFICATIONS_FILTER: 'Filter crew by qualifications',
  QUICK_SETUP_PHASES: 'Resource will assign to these phase(s)',
  QUICK_SETUP_RESOURCES: 'Set resources for tagged phases',
  QUICK_SETUP_STUDENTS: 'Set students of all phases',
  QUICK_SETUP_TIMES: 'Set times of all phases based on EVENT phase',
  QUICK_SETUP_TOGGLE_OFF: 'Turn on SETUP and update this phase',
  QUICK_SETUP_TOGGLE_ON: 'Turn off SETUP'
};

// Button texts
export const BUTTON_TEXTS = {
  CLOSE: 'Close',
  CREATE: 'Create',
  PREV: 'Prev',
  SAVE: 'Save'
};

// Row titles for lesson / currency event detail table
export const LESSON_DETAILS = {
  CANCEL_REASON: 'Cancellation Reason',
  CANCEL_SUB_REASON: 'Cancellation Sub-Reason',
  COMPLETION_PERCENTAGE: 'Completion Percentage(%)',
  CARD_NOTES: 'Card Notes [Displayed]',
  CURRENCY_NAME: 'Currency Event Name',
  DATE: 'Event Date',
  DESCRIPTION: 'Description',
  EXTERNAL_RESOURCE: 'External Resource',
  EVENT_TITLE: 'Event Title',
  EVENT_TYPE: 'Event Type',
  IDENTIFIER: 'Event Designation',
  LAYOUT: 'Layout',
  LESSON_CODE: 'P/A Code',
  LESSON_NAME: 'Activity Name',
  LOCK_EVENT: 'Lock the event',
  NOTES: 'Additional Notes [Hidden]',
  METRIC_TYPES: 'Metric Type',
  OTHER_REASON: 'Other Reason',
  PASSENGERS: 'Passengers',
  PRIORITY: 'Priority',
  SCHOOL: 'Squadron',
  STATUS: 'Status',
  VISIBLE_TO_ALL: 'Visible To All',
};

// The text shown on the left side of swimlane
export const TIMELINE_TITLE = 'EVENT';

// Text to display when a select is not available to select
export const SELECT_NOT_AVAIL = 'N/A';

// Labels for phase details
export const LABELS = {
  ACTUAL: 'Actual Duration',
  ACTUAL_HOURS: 'HOURS',
  ACTUAL_MINUTES: 'MINUTES',
  ADDITIONAL_CREW: 'Additional Crew',
  ADDITIONAL_RESOURCES: 'Additional Resources',
  BASE_CONFIG: 'BASE CONFIG',
  CONFIGS: 'CONFIGS:',
  CREW: 'CREW',
  DURATION: 'Duration',
  FUEL: 'Fuel',
  QUALIFICATIONS_FILTER: 'FILTER:',
  QUICK_SETUP_CONFIGS: 'CONFIGS:',
  QUICK_SETUP_DURATION: 'Event Duration',
  QUICK_SETUP_FUEL: 'Event Fuel',
  QUICK_SETUP_PHASES: 'PHASES:',
  QUICK_SETUP_RESOURCE: 'Resource',
  QUICK_SETUP_RESOURCE_TYPE: 'Resource Type',
  QUICK_SETUP_REQUIREMENT: 'Requirements',
  QUICK_SETUP_START_TIME: 'Event Start Time',
  QUICK_SETUP_STUDENTS: 'Students',
  QUICK_SETUP_TOGGLE_AUTO: 'AUTO',
  QUICK_SETUP_TOGGLE_MANUAL: 'MANUAL',
  REQUIRED_CONFIGS: 'Required Configs',
  REQUIRED_QUALIFICATIONS: 'QUALIFICATIONS:',
  RESOURCE_INSTANCE: 'Resource',
  RESOURCE_TYPE: 'Resource Type',
  START_TIME: 'Start Time',
  STUDENTS: 'Students'
};

// Display messages
export const MESSAGES = {
  EMPTY_CREW: 'No crew required',
  EMPTY_RESOURCES: 'No resources required',
  ERROR_NO_AIRCRAFT: 'Missing aircraft for flight events in the EVENT phase.',
  ERROR_NO_SIMULATOR: 'Missing simulator for simulator events in the EVENT phase.',
  ERROR_NO_STUDENT: 'Missing students for ground school events in the EVENT phase.',
  QUICK_SETUP_BANNER: 'This phase is managed by SETUP.'
};

export const MODAL_SIDE_BAR = {
  LESSON_GUIDE: 'LESSON_GUIDE',
  PERSONNEL: 'PERSONNEL',
  ACTIVITY_REQUEST: 'ACTIVITY_REQUEST',
};
